import { jsxs, jsx } from "react/jsx-runtime";
const IconSkillsSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9.75 21.75a1 1 0 0 1-.955-1.297l1.848-5.953H3.75a1 1 0 0 1-.731-1.683l10.5-11.25a1 1 0 0 1 1.696.946L13.31 9.5h6.94a1 1 0 0 1 .698 1.716l-10.5 10.25a.997.997 0 0 1-.698.284Zm-3.7-9.25H12a1 1 0 0 1 .955 1.297l-1.081 3.481 5.92-5.778H12a1.002 1.002 0 0 1-.965-1.263l1.186-4.347-6.17 6.61Z" })
    ]
  }
);
export {
  IconSkillsSvg
};
